<template>
  <div class="button-div-poi">
    <div class="div-chexbox-button-poi">
      <ListMenuWithCheckbox
        v-if="showPoiMenu || showPoiMenuHover"
        :categories="categories"
        :title="t('general__view__pois')"
        @onChecklistToggle="onChecklistToggle"
        @onHoverListMenu="$emit('onHoverListMenu')"
        @closeHoverListMenu="$emit('closeHoverListMenu')"
      />
      <ButtonSquareHoverChecklist
        :title="t('general__view__pois')"
        :imgSource="iconPoi"
        size="large"
        :activeState="poiButtonActiveState()"
        style="padding-top: 24px"
        @clicked="toggleVisible()"
        @hovered="$emit('PlanviewPoiButtonHovered')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import ListMenuWithCheckbox, {
  CategoryItem
} from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import { useStore } from 'vuex'
import { computed, toRefs, watch } from 'vue'
import { SET_POI_MENU } from '@/store/mutation-types'
import { useI18n } from 'vue-i18n'
import iconPoi from '@/assets/icons-general/icon-poi.svg'

interface Props {
  title: string
  showPoiMenu?: boolean
  categories: CategoryItem[]
  showPoiMenuHover: boolean
}
const props = defineProps<Props>()

const { showPoiMenu, categories, showPoiMenuHover } = toRefs(props)
const { t } = useI18n()
const emits = defineEmits([
  'PlanviewPoiButtonHovered',
  'onChecklistToggle',
  'onHoverListMenu',
  'closeHoverListMenu'
])
const store = useStore()

const poisForSelectedLevel = computed(() => store.state.planview.poisForSelectedLevel)
function poiButtonActiveState() {
  if (!categories.value.length) return 'deactivated'
  return showPoiMenu?.value ? 'active' : 'inactive'
}

function onChecklistToggle(typeId, categoryId, checked) {
  emits('onChecklistToggle', typeId, categoryId, checked)
}
function toggleVisible() {
  if (!categories.value.length) return
  store.commit(SET_POI_MENU, !store.state.showPoiMenu)
}

const poiCategoriesForSelectedLevel = computed(
  () => store.state.planview.poiCategoriesForSelectedLevel
)
watch(poisForSelectedLevel, (newPoisArray) => {
  if (newPoisArray) {
    const updatedCategories = [...poiCategoriesForSelectedLevel.value]
    poiCategoriesForSelectedLevel.value.forEach((poiCategory, categoryIndex) => {
      poiCategory?.types.forEach((poiType, typeIndex) => {
        const poiExistsInType = newPoisArray.find((poi) => poi.properties.typeId === poiType.id)
        // Removing empty type and/or category after poi category is edited
        if (!poiExistsInType && poiType.visible) {
          if (poiCategory.types.length > 1) {
            // Remove the type only from store
            updatedCategories[categoryIndex].types.splice(typeIndex, 1)
          } else if (poiCategory.types.length === 1) {
            // Remove the full category from store
            updatedCategories.splice(categoryIndex, 1)
          }
          store.commit('planview/SET_POI_CATEGORIES_FOR_SELECTED_LEVEL', updatedCategories)
        }
      })
    })
  }
})
</script>

<style lang="scss" scoped>
.button-div-poi {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.div-chexbox-button-poi {
  display: flex;
  justify-content: center;
}
</style>
